import { createSelector } from 'reselect';
import filterFp from 'lodash/fp/filter';
import { map } from 'lodash';
import { curry, allPass, pathOr, pipe, sortBy, assoc } from 'ramda';

import { getById } from '../barbers/selector';
import { fullName } from '../../common/helpers/users';
import { extractFilterIds } from '../reports/selectors';
import { getActiveShop } from '../../auth/selectors';

const denormalizeBarbers = state => (appointment) => {
  appointment.barber = getById(state, appointment.barberId);
  return appointment;
};

const addBarberFullName = (appointment) => {
  appointment.barberFullName = fullName(appointment.barber);
  return appointment;
};

const addBarberColor = (appointment) => {
  appointment.barberColor = pathOr('', ['barber', 'color'])(appointment);
  return appointment;
};

export const getAppointments = (state) => {
  const addBarberData = pipe(denormalizeBarbers(state), addBarberFullName, addBarberColor);
  const ids = state.appointments.items;
  return ids
    .map(id => state.appointments.byId[id])
    .map(addBarberData);
};

export const getAppointment = (state, id) => state.appointments.byId[id];

export const getFilters = state => state.appointments.filters;

export const getAllBarbersFilter = state => state.appointments.barberFilter;
export const getActiveBarbersFilter = createSelector(
  getAllBarbersFilter,
  filterFp(item => item.checked)
);
export const getActiveBarbersFilterIds = createSelector(
  getAllBarbersFilter,
  extractFilterIds
);

export const getBarbersFromFilterSorted = createSelector(
  getActiveBarbersFilter,
  sortBy(barber => barber.order)
);

export const filterAppointmentByStatus = curry((filter, appointment) => !filter || filter.indexOf(appointment.status) > -1);
const filterAppointmentByBarber = curry((filter, appointment) => !filter || filter.indexOf(appointment.barberId) > -1);

const filterAppointments = (filters, barbers, appointments) =>
filterFp(
  allPass([
    filterAppointmentByStatus([0, 2]),
    filterAppointmentByBarber(barbers),
  ])
)(appointments);

export const filteredAppointments = createSelector(
  [getFilters, getActiveBarbersFilterIds, getAppointments],
  filterAppointments
);

export const filteredAppointmentsWithShop = createSelector(
  [getActiveShop, filteredAppointments],
  (shop, appts) => map(appts, assoc('shop', shop)),
);

export const getIsLoading = state => state.appointments.isLoading;

// We ignore timezone, because it will be rewritten soon
// in the constuctor of the AppointmentsWrapper component
export const getDate = state => state.appointments.date || '';

export const getCustomerNotes = pathOr('', ['appointments', 'appointmentForm', 'customerNotes']);

export const getPromoCode = pathOr('', ['appointments', 'appointmentForm', 'promoCode']);
export const getPromoAmount = pathOr(0, ['appointments', 'appointmentForm', 'promoAmount']);
